import { StudentsControlTab, AdminTrackType } from '@shared/models';

import { SHARED_ROUTES } from './shared.routes';

export const SHARED_ADMIN_ROUTES = {
  ...SHARED_ROUTES,

  //dashboard
  dashboard: '/dashboard',
  dashboard_tickets: '/dashboard/tickets',

  //activities
  activities: '/activities',

  //skills
  skills: '/activities/skills',
  skills_add_new_card: (categoryId: string) =>
    `/activities/skills/addNewCard?categoryId=${categoryId}`,
  skills_edit_card: (skillId: string) =>
    `/activities/skills/addNewCard?skillId=${skillId}`,

  //tracks
  tracks: '/activities/tracks',
  tracks_add_new_card: (trackType: AdminTrackType) =>
    `/activities/tracks/${trackType}/addNewCard`,
  tracks_edit_card: (trackType: AdminTrackType, trackId: string) =>
    `/activities/tracks/${trackType}/addNewCard?trackId=${trackId}`,
  tracks_company: (companyId: string) => `tracks/company/${companyId}`,
  tracks_tracksContent: '/activities/tracks/tracksContent',
  tracks_eventsContent: '/activities/tracks/eventsContent',

  //events
  events: '/activities/events',

  //challenges
  challenges: '/activities/challenges',

  // challenges feedback
  challengesFeedback: '/challenges/feedbacks',
  challengesFeedbackDetails: (params: string) =>
    `/challenges/feedbacks/feedback-details${params ? '?' + params : ''}`,
  challengeAdminFeedbacks: '/challenge-feedbacks',
  challengeSubmissions: (challengeId: string, params?: string) =>
    `/challenge-feedbacks/${challengeId}/submissions${
      params ? '?' + params : ''
    }`,
  challengeStudentSubmission: (
    challengeId: string,
    submissionId: string,
    params?: string
  ) =>
    `/challenge-feedbacks/${challengeId}/submissions/${submissionId}${
      params ? '?' + params : ''
    }`,

  //showcase
  showcase: '/activities/showcase',

  //rewards
  rewards: '/activities/rewards',

  //resources
  resources: '/resources',
  activities_resources: '/activities/resources',

  //other
  other: '/activities/other',

  administration: '/administration',

  students: '/students',
  studentsControl: '/administration/' + StudentsControlTab.STUDENTS,
  profile: '/profile',
  news: '/news',
  team: '/team',

  activities_other_OthersContent: '/activities/other/OthersContent',

  activities_showcase_ShowcaseContent: '/activities/showcase/ShowcaseContent',

  communication: '/communication',

  batches: '/batches',
  newBatch: '/batches/add',
  singleBatch: (batchId: string) => `/batches/${batchId}`,

  analyticsGroup: '/analytics-group',
  newAnalyticsGroup: '/analytics-group/add',
  singleAnalyticsGroup: (groupId: string) => `/analytics-group/${groupId}`,

  analytics_group: '/analytics/group',
  analytics_individual: '/analytics/individual',
  analytics_pillar_per_module: (pillarId: string, params: string) =>
    `/analytics/pillar/${pillarId}${params ? '?' + params : ''}`,
  analytics_assessment_results: (params: string) =>
    `/analytics/assessment/results${params ? '?' + params : ''}`,

  billing: '/billing/invoice-history',
  help: '/help',

  // posts
  posts: '/posts',
  singlePost: (postId: string) => `/posts/${postId}`,

  billing_invoice_history: '/billing/invoice-history',
  billing_payment_methods: '/billing/payment-methods',
  subscriptions: '/subscriptions',

  schools: '/schools',
} as const;
